export default {
	APP_CODE: "web_portal",
	APP_CODE_VENDOR: "web_portal_vendor",
	SIDEBAR_TITLE: import.meta.env.VITE_SIDEBAR_TITLE,
	BACKEND_ENDPOINT: import.meta.env.VITE_BACKEND_ENDPOINT,
	BACKEND_FILE_ENDPOINT: import.meta.env.VITE_BACKEND_FILE_ENDPOINT,
	// The consignment gateway is separate and NOT federated into the main supergraph.
	// Empty in production until consignment is deployed there.
	CONSIGNMENT_BACKEND_ENDPOINT: import.meta.env
		.VITE_CONSIGNMENT_BACKEND_ENDPOINT,
	ENABLE_TANSTACK_DEVTOOLS:
		import.meta.env.VITE_ENABLE_TANSTACK_DEVTOOLS === "true",
};

// getActiveAppCode returns the APP_CODE that scopes the current session's
// permissions, derived from the current URL path. /vendor/* runs the vendor
// portal app; everything else is the admin web portal. Detection at call
// time means a single bundle serves both apps without separate builds.
export function getActiveAppCode(): string {
	if (typeof window === "undefined") return "web_portal";
	return window.location.pathname.startsWith("/vendor")
		? "web_portal_vendor"
		: "web_portal";
}
